import React from 'react';
import { Outlet } from 'react-router-dom';
import RcSidebar from './RcSidebar';
import Navbar from '../Navbar';

// Shared layout for all RC routes: sidebar + navbar stay, the page renders in <Outlet/>
const Dashboard = () => {
  return (
    <>
        <RcSidebar/>
        <Navbar/>
        <Outlet/>
    </>
  )
}

export default Dashboard;
